import { Component, OnInit, Input } from '@angular/core';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { AppState } from 'src/app/app.reducer';
import { TemplateEnum } from 'src/app/core/enums/template.enum';
import { getThemeId } from '../../selectors/branding.selector';

@Component({
    selector: 'app-icon-edit',
    templateUrl: './icon-edit.component.html',
    styleUrls: ['./icon-edit.component.scss']
})
export class IconEditComponent implements OnInit {

    @Input() cssClass = 'icon--18';

    template$: Observable<TemplateEnum>;
    templateEnum = TemplateEnum;

    constructor(private store: Store<AppState>) { }

    ngOnInit() {
        this.template$ = this.store.select(getThemeId);
    }

}
